// @ts-nocheck — 디자인 원본 스크립트 포팅 (pricing.js / product.js 의 reveal 부분)
import type { Scope } from './scope';

/** 화면에 들어오면 .in 클래스를 붙여 등장 애니메이션을 실행 (.rv / .pd-rv / .pr-rv) */
export function initReveal(root: ParentNode, s: Scope, selector: string, opts: IntersectionObserverInit = { threshold: 0.12 }) {
  const els = root.querySelectorAll(selector);
  if (!('IntersectionObserver' in window)) {
    els.forEach((e) => e.classList.add('in'));
    return;
  }
  const io = new IntersectionObserver(
    (es) =>
      es.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      }),
    opts,
  );
  els.forEach((e) => io.observe(e));
  s.onDispose(() => io.disconnect());
}
